<template>
  <div>
    <!--  实际支付金额-->
    <div class="actualMoney">
      <div class="row">
        <div class="label item">
          <div class="title">見積時金額</div>
          <div class="value">RMB/円</div>
        </div>
        <div class=" item">
          <div class="title">商品代金</div>
          <div class="value">{{ amount_detail.old.goods_amount }}元</div>
        </div>
        <div class=" item">
          <div class="title">手数料</div>
          <div class="value">{{ amount_detail.old.expense }}元</div>
        </div>
        <div class=" item">
          <div class="title">国内送料</div>
          <div class="value">{{ amount_detail.old.freight }}元</div>
        </div>
        <div class=" item">
          <div class="title">その他</div>
          <div class="value">{{ amount_detail.old.other }}元</div>
        </div>
        <div class=" item">
          <div class="title">合計</div>
          <div class="total">
            <p><span>{{ amount_detail.old.total }} </span>元</p>
            <p><span> {{ amount_detail.old.total_yen }} </span>円</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="label item">
          <div class="title">現在金額</div>
          <div class="value">RMB/円</div>
        </div>
        <div class=" item">
          <div class="title">商品代金</div>
          <div class="value">{{ amount_detail.new.goods_amount }}元</div>
        </div>
        <div class=" item">
          <div class="title">手数料</div>
          <div class="value">{{ amount_detail.new.expense }}元</div>

        </div>
        <div class=" item">
          <div class="title">国内送料</div>
          <div class="value">{{ amount_detail.new.freight }}元</div>

        </div>
        <div class=" item">
          <div class="title">その他</div>
          <div class="value">{{ amount_detail.new.other }}元</div>

        </div>
        <div class=" item">
          <div class="title">合計</div>
          <div class="total">
            <p><span>{{ amount_detail.new.total }} </span>元</p>
            <p><span>{{ amount_detail.new.total_yen }} </span>円</p>
          </div>
        </div>
        <div class=" item">
          <div class="title">差異</div>
          <div class="total">
            <p><span>{{ amount_detail.new.difference }}</span>元</p>
            <p><span>{{ amount_detail.new.difference_yen }}</span>円</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    amount_detail: { type: Object }
  },
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.actualMoney {
  padding: 40px 40px 32px;
  background: #FFF6F6;
  border-radius: 4px;
  margin: 30px 0;

  .row {
    display: flex;

    &:nth-child(1) {
      border-bottom: 1px solid #e9e9e9;
      padding-bottom: 20px;
      margin-bottom: 30px;
    }

    .item {
      width: 100px;
      margin-right: 80px;

      .title {
        margin-bottom: 34px;
      }

      .total {
        padding: 12px;
        width: 100px;
        height: 50px;
        background: #FFF6F6;
        border-radius: 10px;
        border: 1px solid #B7040B;
        margin: -12px 0 0 -12px;

        p {
          line-height: 25px;
        }

        span {
          color: #B7040B;
          font-weight: bold;
        }
      }
    }

    .label {
      font-weight: bold;
    }
  }

}
</style>